import React, { ReactNode } from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
    children?: ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children }) => {
    return (
        <div className='flex justify-between items-center mb-6'>
            <div>
                <h1 className='text-2xl font-bold text-gray-900 dark:text-gray-100'>{title}</h1>
                {subtitle && <p className='mt-1 text-sm text-gray-500 dark:text-gray-400'>{subtitle}</p>}
            </div>
            {children && <div className='flex items-center gap-2'>{children}</div>}
        </div>
    );
};

export default PageHeader;
